import { testResultSchema } from '../testResultSchema'

// 分類定数・フォーム表示用スキーマのみここに置く。OCR専用のプロンプト・OCR出力スキーマは
// @mbscan/backend-ocr（packages/backend/ocr/src/categories/document/schemas/tobuKenzaiHoukokusyo.ts）が正本。

export const tobuKenzaiHoukokusyoDocumentNameText = '圧縮強度試験報告書_東部建材共同試験所'
// 帳票内容から区別する種別。帳票名（プラント側との運用上のフルネーム）と異なり、汎用名を保持する
export const tobuKenzaiHoukokusyoDocumentType = '圧縮強度試験報告書'
export const tobuKenzaiHoukokusyoInspectionCompanyName = '東部建材共同試験所'

export const tobuKenzaiHoukokusyoFormFieldsSchema = testResultSchema.pick({
  打設日: true,
  打設箇所: true,
  Fc_N_per_mm2: true,
  Fq_N_per_mm2: true,
  種類: true,
  呼び強度: true,
  スランプ_cm: true,
  骨材寸法_mm: true,
  セメント: true,
  プラント名: true,
  圧縮強度試験: true,
  // 試験機関名は OCR/検査会社名メタデータ由来の派生値（string[]）で手編集対象にしないため、編集モーダルには出さない。
})
